var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconOfficialBuilding3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m23.88 23.18-2.5-3A.49.49 0 0 0 21 20H3a.49.49 0 0 0-.38.18l-2.5 3a.47.47 0 0 0-.07.53.49.49 0 0 0 .45.29h23a.49.49 0 0 0 .45-.29.47.47 0 0 0-.07-.53"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 8.5,
  x: 3,
  y: 10.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 8.5,
  x: 10,
  y: 10.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 8.5,
  x: 17,
  y: 10.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.08 9.28a.51.51 0 0 0 .42.22h19a.51.51 0 0 0 .42-.22l1-1.5A.5.5 0 0 0 22.5 7h-21a.5.5 0 0 0-.42.78ZM1.5 6h21a.5.5 0 0 0 .21-1l-10.5-5a.45.45 0 0 0-.42 0L1.29 5a.5.5 0 0 0 .21 1"
}))));
export default SvgStreamlineIconOfficialBuilding3;